// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog {
   width: 320px;
   height: 280px;
   /*margin-left: -14px;*/
}

.flag {
   position: relative;
   display: flex;
   flex-flow: row wrap;
}

.blog:hover {
   background-color: #F1F1F1;
}

img.set-height1 {
   /*transform: rotate(90deg);*/
   width: 150px;
   height: 200px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-height2 {
   transform: rotate(180deg);
   width: 150px;
   height: 200px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-height9 {
   transform: rotate(90deg);
   width: 200px;
   height: 150px;
   margin-left: -25px;
   margin-top: 25px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-height8 {
   transform: rotate(-90deg);
   width: 200px;
   height: 150px;
   margin-left: -25px;
   margin-top: 25px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

div.set-height {
   margin-top: 25px;
   margin-left: 40px;
   width: 150px;
   height: 230px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -2px;
   position: absolute;
   left: 9%;
}

div.set-height2 {
   margin-top: 25px;
   margin-left: 40px;
   width: 150px;
   height: 230px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -2px;
}

div.set-height200 {
   margin-top: 25px;
   margin-left: 40px;
   width: 155px;
   height: 230px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -2px;
}

.example-icon {
   cursor: pointer;
}

img.set-width1 {
   width: 200px;
   height: 140px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-width5 {
   width: 150px;
   height: 200px;
   margin-left: 25px;
   margin-top: -25px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-width9 {
   transform: rotate(180deg);
   width: 200px;
   height: 140px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-width2 {
   transform: rotate(90deg);
   width: 150px;
   height: 200px;
   margin-left: 25px;
   margin-top: -25px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

img.set-width3 {
   transform: rotate(-90deg);
   width: 150px;
   height: 200px;
   margin-left: 25px;
   margin-top: -25px;
   border-width: 1px;
   border-color: #aea2af;
   border-style: solid;
}

div.set-width {
   margin-top: 50px;
   margin-left: 20px;
   width: 200px;
   height: 185px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

div.set-width100 {
   margin-top: 50px;
   margin-left: 20px;
   width: 205px;
   height: 185px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

div.set-width10 {
   margin-top: 50px;
   margin-left: 20px;
   width: 200px;
   height: 175px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

div.set-width1 {
   margin-top: 50px;
   margin-left: 20px;
   width: 200px;
   height: 175px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

div.set-width101 {
   margin-top: 50px;
   margin-left: 20px;
   width: 205px;
   height: 175px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

.active-thumbnails-height {
   border-width: 2px;
   border-color: #2AB4C0;
   border-style: solid;
   margin-top: 25px;
   margin-left: 40px;
   width: 156px;
   z-index: 99;
   height: 232px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -2px;
}

.active-thumbnails-width {
   border-width: 2px;
   z-index: 99;
   border-color: #2AB4C0;
   border-style: solid;
   margin-top: 50px;
   margin-left: 20px;
   width: 205px;
   height: 175px;
   background-color: white;
   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   margin-bottom: -4px;
}

.checkbox {
   margin-left: 50px;
   margin-top: 50px;
}

div.container1 {
   margin-top: -20px;
   margin-bottom: -5px;
}

div.container2 {
   margin-top: 5px;
   margin-bottom: -5px;
}

div.container3 {
   margin-top: 27px;
   margin-bottom: -5px;
}

div.container {
   margin-bottom: -5px;
}

.page {
   font-size: 12px;
   margin-left: 4px;
}

.example-icon {
   font-size: 18px;
}

.example {
   font-size: 18px;
}

button {
   margin-top: -12px;
}

.rotate1 {
   margin-left: 15px;
}

.icon-set {
   margin-right: 4px;
   float: right;
}

.rotate { /* IE 9 */ /* Safari 3-8 */
   transform: rotate(90deg);
}

.blog-center {
   margin: 130px 2px 25px;
}

div.set-crete {
   margin-left: 60px;
}

.warning-hover:hover {
   color: #2ab4c0;
   background-color: rgba(0, 178, 201, .1);
}

.spinner-height {
   margin-left: 40%;
   margin-top: 60%;
}

.spinner-width {
   margin-left: 38%;
   margin-top: 30%;
}

.spinner-height {
   margin-left: 40%;
   margin-top: 60%;
}

.spinner-width {
   margin-left: 38%;
   margin-top: 30%;
}`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-document/thumbnail/thumbnail.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ,aAAa;GACb,sBAAsB;AACzB;;AAEA;GACG,kBAAkB;GAClB,aAAa;GACb,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,4BAA4B;GAC5B,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,wBAAwB;GACxB,YAAY;GACZ,aAAa;GACb,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,aAAa;GACb,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;GACnB,kBAAkB;GAClB,QAAQ;AACX;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,iBAAiB;GACjB,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,wBAAwB;GACxB,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,iBAAiB;GACjB,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,aAAa;GACb,iBAAiB;GACjB,iBAAiB;GACjB,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,iBAAiB;GACjB,qBAAqB;GACrB,mBAAmB;GACnB,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,WAAW;GACX,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,iBAAiB;GACjB,WAAW;GACX,qBAAqB;GACrB,mBAAmB;GACnB,gBAAgB;GAChB,iBAAiB;GACjB,YAAY;GACZ,aAAa;GACb,uBAAuB;GACvB,4EAA4E;GAC5E,mBAAmB;AACtB;;AAEA;GACG,iBAAiB;GACjB,gBAAgB;AACnB;;AAEA;GACG,iBAAiB;GACjB,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;GACjB,YAAY;AACf;;AAEA,UACiC,SAAS,EACL,eAAe;GACjD,wBAAwB;AAC3B;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,cAAc;GACd,uCAAuC;AAC1C;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB","sourcesContent":[".blog {\n   width: 320px;\n   height: 280px;\n   /*margin-left: -14px;*/\n}\n\n.flag {\n   position: relative;\n   display: flex;\n   flex-flow: row wrap;\n}\n\n.blog:hover {\n   background-color: #F1F1F1;\n}\n\nimg.set-height1 {\n   /*transform: rotate(90deg);*/\n   width: 150px;\n   height: 200px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-height2 {\n   transform: rotate(180deg);\n   width: 150px;\n   height: 200px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-height9 {\n   transform: rotate(90deg);\n   width: 200px;\n   height: 150px;\n   margin-left: -25px;\n   margin-top: 25px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-height8 {\n   transform: rotate(-90deg);\n   width: 200px;\n   height: 150px;\n   margin-left: -25px;\n   margin-top: 25px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\ndiv.set-height {\n   margin-top: 25px;\n   margin-left: 40px;\n   width: 150px;\n   height: 230px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -2px;\n   position: absolute;\n   left: 9%;\n}\n\ndiv.set-height2 {\n   margin-top: 25px;\n   margin-left: 40px;\n   width: 150px;\n   height: 230px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -2px;\n}\n\ndiv.set-height200 {\n   margin-top: 25px;\n   margin-left: 40px;\n   width: 155px;\n   height: 230px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -2px;\n}\n\n.example-icon {\n   cursor: pointer;\n}\n\nimg.set-width1 {\n   width: 200px;\n   height: 140px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-width5 {\n   width: 150px;\n   height: 200px;\n   margin-left: 25px;\n   margin-top: -25px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-width9 {\n   transform: rotate(180deg);\n   width: 200px;\n   height: 140px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-width2 {\n   transform: rotate(90deg);\n   width: 150px;\n   height: 200px;\n   margin-left: 25px;\n   margin-top: -25px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\nimg.set-width3 {\n   transform: rotate(-90deg);\n   width: 150px;\n   height: 200px;\n   margin-left: 25px;\n   margin-top: -25px;\n   border-width: 1px;\n   border-color: #aea2af;\n   border-style: solid;\n}\n\ndiv.set-width {\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 200px;\n   height: 185px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\ndiv.set-width100 {\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 205px;\n   height: 185px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\ndiv.set-width10 {\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 200px;\n   height: 175px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\ndiv.set-width1 {\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 200px;\n   height: 175px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\ndiv.set-width101 {\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 205px;\n   height: 175px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\n.active-thumbnails-height {\n   border-width: 2px;\n   border-color: #2AB4C0;\n   border-style: solid;\n   margin-top: 25px;\n   margin-left: 40px;\n   width: 156px;\n   z-index: 99;\n   height: 232px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -2px;\n}\n\n.active-thumbnails-width {\n   border-width: 2px;\n   z-index: 99;\n   border-color: #2AB4C0;\n   border-style: solid;\n   margin-top: 50px;\n   margin-left: 20px;\n   width: 205px;\n   height: 175px;\n   background-color: white;\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n   margin-bottom: -4px;\n}\n\n.checkbox {\n   margin-left: 50px;\n   margin-top: 50px;\n}\n\ndiv.container1 {\n   margin-top: -20px;\n   margin-bottom: -5px;\n}\n\ndiv.container2 {\n   margin-top: 5px;\n   margin-bottom: -5px;\n}\n\ndiv.container3 {\n   margin-top: 27px;\n   margin-bottom: -5px;\n}\n\ndiv.container {\n   margin-bottom: -5px;\n}\n\n.page {\n   font-size: 12px;\n   margin-left: 4px;\n}\n\n.example-icon {\n   font-size: 18px;\n}\n\n.example {\n   font-size: 18px;\n}\n\nbutton {\n   margin-top: -12px;\n}\n\n.rotate1 {\n   margin-left: 15px;\n}\n\n.icon-set {\n   margin-right: 4px;\n   float: right;\n}\n\n.rotate {\n   -ms-transform: rotate(90deg); /* IE 9 */\n   -webkit-transform: rotate(90deg); /* Safari 3-8 */\n   transform: rotate(90deg);\n}\n\n.blog-center {\n   margin: 130px 2px 25px;\n}\n\ndiv.set-crete {\n   margin-left: 60px;\n}\n\n.warning-hover:hover {\n   color: #2ab4c0;\n   background-color: rgba(0, 178, 201, .1);\n}\n\n.spinner-height {\n   margin-left: 40%;\n   margin-top: 60%;\n}\n\n.spinner-width {\n   margin-left: 38%;\n   margin-top: 30%;\n}\n\n.spinner-height {\n   margin-left: 40%;\n   margin-top: 60%;\n}\n\n.spinner-width {\n   margin-left: 38%;\n   margin-top: 30%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
